import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { setPluginConfig } from './config';

export { default as CampaignProvider } from './context/CampaignProvider';
export { useCampaignAttribution } from './context/CampaignContext';

export default async function load(app, options = {}) {
  // Attribution rule, expiry and consent strategy. See config.js.
  setPluginConfig(options);

  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}

load.pluginName = PLUGIN_NAME;
